import React from "react";
import ImageSlide from "../../components/carousel/imageSlide";
import Modal from "../../components/modal";
import Cards from "../../components/cards";
import { mobileView } from "../viewType";

function ImageSlideModal({ closeImageSlideShow, imageSlideArray, modalData }) {
	const close = () => {
		closeImageSlideShow();
	};
	
	return (
		<Modal>
			<Modal.ModalWrapper>
				<div
					style={{
						backgroundColor: "#FFFFFF",
						width: mobileView ? "98%" : "60%",
						height: "auto",
						padding: mobileView ? "5px" : "12px",
					}}
				>
					<div>
						<Cards.TitleContainer
							style={{ display: "flex", alignItems: "center" }}
						>
							<Cards.TextContainer>
								<Cards.Title>
									{modalData?.["raw_data"]?.["make"] ? modalData?.["raw_data"]?.["make"] : modalData?.["make"]}{" "}
									{modalData?.["raw_data"]?.["model"] ? modalData?.["raw_data"]?.["model"] : modalData?.["model"]}
								</Cards.Title>
								<Cards.SmallText>
									Brand: {modalData?.["raw_data"]?.["make"] ? modalData?.["raw_data"]?.["make"] : modalData?.["make"]}
								</Cards.SmallText>
							</Cards.TextContainer>
							<div style={{ display: "flex", alignItems: "center" }}>
								<Cards.MoreInfoButton
									onClick={close}
									style={{
										marginLeft: "auto",
										marginTop: "6px",
										marginBottom: "6px",
									}}
								>
									CLOSE
									<img src="../../assets/icons/close.svg" alt="close" />
								</Cards.MoreInfoButton>
							</div>
						</Cards.TitleContainer>
					</div>
						<ImageSlide imageSlideArray={imageSlideArray} />
				</div>
			</Modal.ModalWrapper>
		</Modal>
	);
}

export default ImageSlideModal;
